
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_14yj0_65h5j_93",
  "no-gutters": "awsui_no-gutters_14yj0_65h5j_131",
  "grid-column": "awsui_grid-column_14yj0_65h5j_135",
  "colspan-1": "awsui_colspan-1_14yj0_65h5j_144",
  "push-1": "awsui_push-1_14yj0_65h5j_148",
  "pull-1": "awsui_pull-1_14yj0_65h5j_151",
  "colspan-2": "awsui_colspan-2_14yj0_65h5j_154",
  "push-2": "awsui_push-2_14yj0_65h5j_158",
  "pull-2": "awsui_pull-2_14yj0_65h5j_161",
  "colspan-3": "awsui_colspan-3_14yj0_65h5j_164",
  "push-3": "awsui_push-3_14yj0_65h5j_168",
  "pull-3": "awsui_pull-3_14yj0_65h5j_171",
  "colspan-4": "awsui_colspan-4_14yj0_65h5j_174",
  "push-4": "awsui_push-4_14yj0_65h5j_178",
  "pull-4": "awsui_pull-4_14yj0_65h5j_181",
  "colspan-5": "awsui_colspan-5_14yj0_65h5j_184",
  "push-5": "awsui_push-5_14yj0_65h5j_188",
  "pull-5": "awsui_pull-5_14yj0_65h5j_191",
  "colspan-6": "awsui_colspan-6_14yj0_65h5j_194",
  "push-6": "awsui_push-6_14yj0_65h5j_198",
  "pull-6": "awsui_pull-6_14yj0_65h5j_201",
  "colspan-7": "awsui_colspan-7_14yj0_65h5j_204",
  "push-7": "awsui_push-7_14yj0_65h5j_208",
  "pull-7": "awsui_pull-7_14yj0_65h5j_211",
  "colspan-8": "awsui_colspan-8_14yj0_65h5j_214",
  "push-8": "awsui_push-8_14yj0_65h5j_218",
  "pull-8": "awsui_pull-8_14yj0_65h5j_221",
  "colspan-9": "awsui_colspan-9_14yj0_65h5j_224",
  "push-9": "awsui_push-9_14yj0_65h5j_228",
  "pull-9": "awsui_pull-9_14yj0_65h5j_231",
  "colspan-10": "awsui_colspan-10_14yj0_65h5j_234",
  "push-10": "awsui_push-10_14yj0_65h5j_238",
  "pull-10": "awsui_pull-10_14yj0_65h5j_241",
  "colspan-11": "awsui_colspan-11_14yj0_65h5j_244",
  "push-11": "awsui_push-11_14yj0_65h5j_248",
  "pull-11": "awsui_pull-11_14yj0_65h5j_251",
  "colspan-12": "awsui_colspan-12_14yj0_65h5j_254",
  "push-12": "awsui_push-12_14yj0_65h5j_258",
  "pull-12": "awsui_pull-12_14yj0_65h5j_261",
  "push-0": "awsui_push-0_14yj0_65h5j_264",
  "pull-0": "awsui_pull-0_14yj0_65h5j_267",
  "offset-1": "awsui_offset-1_14yj0_65h5j_270",
  "offset-2": "awsui_offset-2_14yj0_65h5j_273",
  "offset-3": "awsui_offset-3_14yj0_65h5j_276",
  "offset-4": "awsui_offset-4_14yj0_65h5j_279",
  "offset-5": "awsui_offset-5_14yj0_65h5j_282",
  "offset-6": "awsui_offset-6_14yj0_65h5j_285",
  "offset-7": "awsui_offset-7_14yj0_65h5j_288",
  "offset-8": "awsui_offset-8_14yj0_65h5j_291",
  "offset-9": "awsui_offset-9_14yj0_65h5j_294",
  "offset-10": "awsui_offset-10_14yj0_65h5j_297",
  "offset-11": "awsui_offset-11_14yj0_65h5j_300",
  "restore-pointer-events": "awsui_restore-pointer-events_14yj0_65h5j_304"
};
  